import { createSvgIcon } from '@mui/material';
import { ReactNode } from 'react';

const svg: ReactNode = (
  <path
    d="M7.45002 21.952C7.19302 21.952 6.93702 21.852 6.74102 21.655C6.35502 21.264 6.35902 20.634 6.75102 20.248L15.131 11.979L6.75202 3.75301C6.36002 3.36801 6.35402 2.73801 6.73902 2.34601C7.12202 1.95401 7.75402 1.94801 8.14602 2.33301L17.246 11.266C17.436 11.453 17.545 11.708 17.545 11.975C17.545 12.242 17.44 12.497 17.248 12.685L8.14802 21.665C7.95402 21.856 7.70202 21.952 7.44902 21.952H7.45002Z"
    fill="currentColor"
  />
);

const Icon = createSvgIcon(svg, 'ChevronRight');

export default Icon;
